import { Client, fetchExchange, ssrExchange } from "urql";
import createSerializeScalarsExchange from "@cprm/urql-serialize-scalars-exchange-esm";
import { scalarLocations } from "./scalarLocations";
import { getGraphqlUrl } from "./url_helpers";

const isServerSide = typeof window === "undefined";
const ssr = ssrExchange({
  isClient: !isServerSide,
  // @ts-ignore
  initialState: !isServerSide ? window.__URQL_DATA__ : undefined,
});

const serializeScalarsExchange = createSerializeScalarsExchange(
  scalarLocations,
  {
    Json: {
      serialize: (v: any) => (typeof v === "string" ? v : JSON.stringify(v)),
      deserialize: (v: string) => JSON.parse(v),
    },
    DateTime: {
      serialize: (v: Date) => {
        return v.toISOString();
      },
      deserialize: (v: string) => {
        return new Date(v);
      },
    },
  }
);

export const getGraphqlClientSideClient = () => {
  const graphqlClient = new Client({
    url: getGraphqlUrl(),
    requestPolicy: "network-only",
    fetchOptions: heplerFetchOptions,
    exchanges: [serializeScalarsExchange, ssr, fetchExchange],
  });
  return graphqlClient;
};

const heplerFetchOptions = () => {
  return {
    headers: {
      Authorization: `Bearer ` + window.localStorage.getItem("graphToken"),
    },
  };
};
